<template>
  <v-container id="dashboard" fluid tag="section">
    <span class="background" />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'

  export default Vue.extend({
    name: 'DashboardDashboard',
    mounted() {
      this.fetchPermission()
    },
    methods: {
      ...mapActions('Dashboard', ['fetchPermission']),
    },
  })
</script>

<style lang="sass">
  #dashboard
    .summary-table
      .v-data-table table
        margin-top: 10px
      .v-data-table table thead tr th
        font-size: 16px
        vertical-align: top

    .background
      margin-top: 50px
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      background: url('/images/opus-background.png') no-repeat center center
      background-size: cover
      background-color: #000
      transform: scale(1.05)
</style>
